<template>
  <b-container fluid>
    <!-- <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('awareness_config.event_type_setup') }}</h4>
        </template>
        <b-row>
            <b-col xs="6" sm="6" md="6" lg="6" xl="6" class="ml-4 mt-4 mb-2">
            <ValidationProvider>
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="org_name"
                    slot-scope="{ valid, errors }"
                >
                <template v-slot:label>
                    {{ $t('awareness_config.event_type_setup_name')}}
                </template>
                    <b-form-input
                    id="org_name"
                    v-model="search.org_name"
                    :state="errors[0] ? false : (valid ? true : null)"
                    ></b-form-input>
                    <div class="invalid-feedback">
                    {{ errors[0] }}
                    </div>
                </b-form-group>
            </ValidationProvider>
            </b-col>
            <b-col xs="2" sm="2" md="2" lg="2" xl="2" class="ml-4 mt-4 mb-2">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
        </b-row>
    </iq-card> -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('externalUser.apply_for_stall') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:headerAction>
            <!-- <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              {{  $t('globalTrans.add_new') }}
            </b-button> -->
            <router-link to="apply-stall-form" :class="'btn btn-success text-white'">{{  $t('globalTrans.add_new') }}</router-link>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="items" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(assign_status)="data">
                        <span class="badge badge-warning" v-if="data.item.assign_status == 1">{{$t('globalTrans.not_assigned')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.assigned')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="view(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                      <router-link title="Edit" v-if="data.item.payment_status == 1" :to="`/stall-participant/apply-stall-form?id=${data.item.id}`" class="btn btn-sm btn-warning"><i class="ri-ball-pen-fill m-0"></i></router-link>
                      <b-button  v-b-modal.modal-money-receipt v-if="data.item.payment_status == 2"  title="Money Receipt" class="btn-outline-success mt-1" variant=" iq-bg-success ml-1" size="sm" @click="showMoneyReceipt(data.item)"><i class="ri-money-dollar-box-line m-0"></i></b-button>
                      <b-button v-if="data.item.save_status === 1 && data.item.payment_status === 1" v-b-modal.modal-payment variant=" iq-bg-success mr-1 mb-1" size="sm" @click="payment(data.item)" title="Payment">{{$t('externalUser.payment')}}</b-button>
                    </template>
                   <template v-slot:cell(payment_status)="data">
                        <span class="badge badge-warning" v-if="data.item.payment_status == 1">{{$t('event_manage.un_paid')}}</span>
                        <span class="badge badge-success" v-else>{{$t('event_manage.paid')}}</span>
                   </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="lg" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <p>
        <FormV :id="editItemId" :key="editItemId" :item="item"/>
      </p>
    </b-modal>
    <b-modal id="modal-detail" size="lg" :title="$t('globalTrans.details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <DetailModal :id="viewitemId" :key="viewitemId"/>
    </b-modal>
    <b-modal id="modal-money-receipt" size="md" :title="$t('externalUser.money_receipt_title')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <MoneyReceipt :id="viewpaymentId" :key="viewpaymentId"  :item="item"/>
    </b-modal>
    <b-modal id="modal-payment" size="md" :title="$t('externalUser.payment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Payment :singleData="singleTest" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import FormV from './Form'
import DetailModal from './Details'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { applyStallList, EventTypeToggleStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
// import MoneyReceipt from './MoneyReceipt'
import Payment from './Payment'
import MoneyReceipt from './MoneyReceipt'

export default {
    mixins: [ModalBaseMasterList],
    components: {
        FormV, DetailModal, Payment, MoneyReceipt
    },
    data () {
        return {
          ItemShow: false,
          editItemId: '',
          items: [],
          item: [],
          viewitemId: 0,
          viewpaymentId: '',
          singleTest: [],
          paymentTypeList: [
            { value: 1, text_en: 'Online Payment', text_bn: ' অনলাইন পেমেন্ট' },
            { value: 2, text_en: 'Check Payment', text_bn: 'পেমেন্ট চেক' },
            { value: 3, text_en: 'Cash Payment', text_bn: 'নগদে টাকা প্রদান' }
          ]
        }
    },
    created () {
        // this.loadData()
        this.paymentStatusUpdate()
    },
    computed: {
        formTitle () {
            return (this.editItemId === 0) ? this.$t('awareness_config.event_type_only') + ' ' + this.$t('globalTrans.entry') : this.$t('awareness_config.event_type_only') + ' ' + this.$t('globalTrans.modify')
        },
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('awareness_config.year'), class: 'text-left' },
                { label: this.$t('externalUser.registration_id'), class: 'text-left' },
                { label: this.$t('awareness_config.event_type'), class: 'text-left' },
                { label: this.$t('awareness_config.event_name'), class: 'text-left' },
                { label: this.$t('awareness_config.stall_type'), class: 'text-left' },
                { label: this.$t('externalUser.total_rent'), class: 'text-left' },
                { label: this.$t('awareness_config.status'), class: 'text-left' },
                { label: this.$t('event_manage.payment_status'), class: 'text-left' },
                { label: this.$t('event_manage.payment_type'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'year' },
                    { key: 'registration_id' },
                    { key: 'event_type_name_bn' },
                    { key: 'event_name_bn' },
                    { key: 'stall_type_name_bn' },
                    { key: 'total_cost' },
                    { key: 'assign_status' },
                    { key: 'payment_status' },
                    { key: 'payment_type_bn' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'year' },
                    { key: 'registration_id' },
                    { key: 'event_type_name' },
                    { key: 'event_name' },
                    { key: 'stall_type_name' },
                    { key: 'total_cost' },
                    { key: 'assign_status' },
                    { key: 'payment_status' },
                    { key: 'payment_type' },
                    { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
      }
    },
    methods: {
      payment (item) {
        this.singleTest = item
      },
      async paymentStatusUpdate () {
        if (this.$route.params.status && this.$route.query.transId) {
          const status = this.$route.params.status
          const tranId = this.$route.query.transId
          await RestApi.getData(awarenessEventServiceBaseUrl, 'stall-participant/payment-status/' + status, { transId: tranId }).then(response => {
            if (response.success) {
              if (response.notification && this.$store.state.emitNotification) {
                this.$socket.emit('send-notification', response.notification)
              }
              this.$toast.success({
                title: 'Success',
                message: response.message,
                color: '#D6E09B'
              })
            } else {
              this.$toast.error({
                title: 'Error',
                message: response.message
              })
            }
          })
          this.loadData()
          this.$router.push('/stall-participant/apply-stall-list')
        } else {
          this.loadData()
        }
      },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
        view (viewitem) {
          this.viewitemId = viewitem.id
        },
        showMoneyReceipt (paymentitem) {
          this.viewpaymentId = paymentitem.id
        },
        remove (item) {
            this.changeStatus(awarenessEventServiceBaseUrl, EventTypeToggleStatusApi, item, 'awareness_event_service', 'eventTypeList')
        },
        loadData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(awarenessEventServiceBaseUrl, applyStallList, params).then(response => {
                if (response.success) {
                  this.items = this.getRelationalData(response.data.data)
                  this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                  this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
        getRelationalData (data) {
            let eventList = {}
            let eventTypeList = {}
            let stallTypeList = {}
            const listData = data.map(item => {
                eventList = this.$store.state.ExternalUser.stallParticipantCommonObj.eventList.find(event => event.value === item.event_info_id)
                const list = {
                    event_name: eventList !== undefined ? eventList.text_en : '',
                    event_name_bn: eventList !== undefined ? eventList.text_bn : ''
                }
                eventTypeList = this.$store.state.ExternalUser.stallParticipantCommonObj.eventTypeList.find(data => data.value === item.event_type_id)
                const eTypeList = {
                    event_type_name: eventTypeList !== undefined ? eventTypeList.text_en : '',
                    event_type_name_bn: eventTypeList !== undefined ? eventTypeList.text_bn : ''
                }
                stallTypeList = this.$store.state.ExternalUser.stallParticipantCommonObj.stallTypeList.find(data => data.value === item.stall_type_id)
                const sTypeList = {
                    stall_type_name: stallTypeList !== undefined ? stallTypeList.text_en : '',
                    stall_type_name_bn: stallTypeList !== undefined ? stallTypeList.text_bn : ''
                }
                const paymentMethodList = this.paymentTypeList.find(data => data.value === item.payment_type_id)
                const paymentObj = {
                    payment_type: paymentMethodList !== undefined ? paymentMethodList.text_en : '',
                    payment_type_bn: paymentMethodList !== undefined ? paymentMethodList.text_bn : ''
                }
                return Object.assign({}, item, list, eTypeList, sTypeList, paymentObj)
            })
            return listData
        },
        searchData () {
          this.loadData()
        }
    }
  }
</script>

<style scoped>
  .width-fixed {
    width: 25%
  }
</style>
